export default __webpack_public_path__ + "static/media/remove.d0a27f3f.svg";